<template>
  <modal
    :linkClass="'action-icon'"
    :modalId="name+'-'+index"
    :title="title"
    :modalSize="'large'"
    :footer="true"
  >
    <template slot="modalLink">
      <i class="far fa-edit" title="Plaatsing aanpassen"></i>
    </template>
    <template slot="modalBody">
      <form v-on:submit.prevent="$emit('saveChanges')">
        <div class="row">
          <div class="form-group col-6">
            <label for="hourlyWage">Salaris (p/u)</label>
            <input v-validate="'required'"
                   name="hourlyWage"
                   id="hourlyWage"
                   type="number"
                   class="form-control"
                   v-model="placementEdit.hourlyWage">
          </div>
          <div class="col-6">
            <label>Einddatum</label>
            <datepicker
              :language="nl"
              id="endDate"
              v-model="placementEdit.endDate"
              :fullMonthName="true"
              format="dd-MM-yyyy"
              input-class="form-control"
              :calendar-button="true"
              :calendar-button-icon="'far fa-calendar-alt'"
              :clear-button="true"
              :clear-button-icon="'far fa-times'"
              :disabled-dates="disabledEndDates"
            ></datepicker>
          </div>
        </div>
        <div class="row" v-if="asksForTakeover">
          <div class="form-group col-12">
            <label>Wordt deze kandidaat overgenomen? <span class="text-danger">*</span></label>
            <div class="form-group inline-radios mb-0">
              <div class="custom-control custom-radio" v-for="option in takeoverOptions" :key="option.label">
                <input type="radio"
                       class="custom-control-input"
                       name="takenOver"
                       :id="'takenOver-' + option.label + '-' + name + '-' + index"
                       :value="option.value"
                       v-model="placementEdit.takenOver"
                       v-validate="'required'">
                <label class="custom-control-label" :for="'takenOver-' + option.label + '-' + name + '-' + index">{{ option.label }}</label>
              </div>
            </div>
            <span v-if="errors.first('takenOver')" class="small text-danger">Kies of de kandidaat wordt overgenomen</span>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <label>Pensioen</label>
              <v-select :options="getStandardFormChoices('retirements')"
                        v-model="placementEdit.retirement"
                        label="name"
                        :selectOnTab="true"
              />
          </div>
        </div>
      </form>
    </template>

    <div class="modal-footer" slot="modalFooter">
      <button type="button" class="btn btn-outline-secondary" data-dismiss="modal">Annuleren</button>
      <button type="button" class="btn btn-primary" @click="validateBeforeSave">
        <i class="fal fa-save mr-2"></i> Opslaan
      </button>
    </div>
  </modal>
</template>

<script>
  import {mapGetters} from 'vuex';
  import Datepicker from "vuejs-datepicker";
  import {nl} from "vuejs-datepicker/dist/locale";
  import {asksForTakeover} from "@/utils/placementTakeover";

  export default {
    components: {
      Datepicker
    },
    data() {
      return {
        nl: nl,
        takeoverOptions: [{label: 'Ja', value: true}, {label: 'Nee', value: false}],
        placementEdit: {
          id: null,
          endDate: null,
          hourlyWage: null,
          retirement: null,
          takenOver: null
        }
      };
    },
    props: ["index", "title", "placement", "name"],
    methods: {
      validateBeforeSave() {
        this.$validator.validateAll().then((result) => {
          if (result) {
            this.placementEdit.endDate = this.placementEdit.endDate ? this.placementEdit.endDate : null;
            this.$emit('saveChanges', this.placementEdit);
          }
        });
      }
    },
    computed: {
      ...mapGetters("candidates", ["getStandardFormChoices"]),
      asksForTakeover() {
        return asksForTakeover(this.placement, this.placementEdit.endDate);
      },
      disabledEndDates() {
        return {
          to: new Date(this.placement.startDate),
        }
      }
    },
    created() {
      this.placementEdit.id = this.placement.id
      this.placementEdit.endDate = this.placement.endDate
      this.placementEdit.hourlyWage = this.placement.hourlyWage
      this.placementEdit.retirement = this.placement.retirement
      this.placementEdit.takenOver = typeof this.placement.takenOver === 'boolean' ? this.placement.takenOver : null
    }
  };
</script>
